// Símbolos que se pueden asignar a una categoría de armarios para marcarlos en los planos.
// Las formas (forma: true) se pintan tal cual con el color de la categoría; el resto de
// iconos van en blanco dentro de un círculo del color de la categoría.
export const SIMBOLO_DEFECTO = "mdi-circle";

export const SIMBOLOS = [
  { icono: "mdi-circle", nombre: "Punto", forma: true },
  { icono: "mdi-square", nombre: "Cuadrado", forma: true },
  { icono: "mdi-rhombus", nombre: "Rombo", forma: true },
  { icono: "mdi-triangle", nombre: "Triángulo", forma: true },
  { icono: "mdi-star", nombre: "Estrella", forma: true },
  { icono: "mdi-flash", nombre: "Eléctrico" },
  { icono: "mdi-electric-switch", nombre: "Interruptor" },
  { icono: "mdi-power-plug", nombre: "Enchufe" },
  { icono: "mdi-lightbulb", nombre: "Iluminación" },
  { icono: "mdi-battery", nombre: "Batería" },
  { icono: "mdi-locker-multiple", nombre: "Armario" },
  { icono: "mdi-server", nombre: "Rack" },
  { icono: "mdi-robot-industrial", nombre: "Máquina" },
  { icono: "mdi-engine", nombre: "Motor" },
  { icono: "mdi-cog", nombre: "Mecánico" },
  { icono: "mdi-pump", nombre: "Bomba" },
  { icono: "mdi-valve", nombre: "Válvula" },
  { icono: "mdi-water", nombre: "Agua" },
  { icono: "mdi-fan", nombre: "Ventilación" },
  { icono: "mdi-snowflake", nombre: "Frío" },
  { icono: "mdi-thermometer", nombre: "Temperatura" },
  { icono: "mdi-gauge", nombre: "Medidor" },
  { icono: "mdi-wifi", nombre: "Comunicaciones" },
  { icono: "mdi-cctv", nombre: "Cámara" },
  { icono: "mdi-fire-extinguisher", nombre: "Extintor" },
  { icono: "mdi-alert", nombre: "Aviso" },
];

/** Datos del símbolo de un icono (los desconocidos se pintan como icono dentro de un círculo) */
export function simbolo(icono) {
  return SIMBOLOS.find((s) => s.icono === icono) || { icono: icono || SIMBOLO_DEFECTO, nombre: "", forma: !icono };
}
